import { combineReducers } from 'redux';

import type { Reducer } from 'Lib/reduxType';

import {
  getCommonResetAction,
  STATE_ERROR,
  STATE_LOADING,
  STATE_SUCCESS,
} from 'Store/commonActions';
import { LOGIN_START, SUBMIT_FACEBOOK_TOKEN } from 'Store/mfa/constants';

import {
  FACEBOOK_SDK_BLOCKED,
  FACEBOOK_SDK_INITIALIZED,
  RESET_FACEBOOK_TOKEN_STATE,
  VALIDATE_FACEBOOK_TOKEN_ERROR,
  VALIDATE_FACEBOOK_TOKEN_SUCCESS,
} from './constants';
import initialState from './initialState';
import { FacebookState } from './types';

const facebookInitializedReducer: Reducer<FacebookState['facebookInitialized']> = (
  state = initialState.facebookInitialized,
  action
) => {
  switch (action.type) {
    case FACEBOOK_SDK_INITIALIZED:
      return true;
    default:
      return state;
  }
};

const facebookSdkBlockedReducer: Reducer<FacebookState['facebookSdkBlocked']> = (
  state = initialState.facebookSdkBlocked,
  action
) => {
  switch (action.type) {
    case FACEBOOK_SDK_BLOCKED:
      return true;
    default:
      return state;
  }
};

const facebookTokenStateReducer: Reducer<FacebookState['facebookTokenState']> = (
  state = initialState.facebookTokenState,
  action
) => {
  switch (action.type) {
    case SUBMIT_FACEBOOK_TOKEN:
      return STATE_LOADING;
    case VALIDATE_FACEBOOK_TOKEN_SUCCESS:
      return STATE_SUCCESS;
    case VALIDATE_FACEBOOK_TOKEN_ERROR:
      return STATE_ERROR;
    case RESET_FACEBOOK_TOKEN_STATE:
    case LOGIN_START:
    case getCommonResetAction(action.type):
      return initialState.facebookTokenState;
    default:
      return state;
  }
};

export const reducer = combineReducers({
  facebookInitialized: facebookInitializedReducer,
  facebookSdkBlocked: facebookSdkBlockedReducer,
  facebookTokenState: facebookTokenStateReducer,
});
